module.exports = __webpack_public_path__ + "static/img/Leader4@2x.36376790.png";